<template>
	<div>
		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height" @show="modal_onshow" show-footer @hide="modal_onhide"
			destroy-on-close>
			<template #default>
				<vxe-grid ref="logisticsotherdetailList" v-if="list_gridOptions" v-bind="list_gridOptions" @toolbar-button-click="list_toolbarButtonClickEvent"></vxe-grid>
				<config ref="config" :row="row" :otherrow="otherrow" @success="configSubmit" />	
			</template>
			<template #footer>
				<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
			</template>
		</vxe-modal>
		
	</div>
</template>
<style scoped>

</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	import config from './config.vue'
	export default {
		mixins: [listMixins,modalMixins],
		props: {
			row: {
				default: () => {
					return {}
				}
			},
		},
		data() {
			return {
				modal_model:false,
				modal_title: '其他时段',
				modal_width:800,
				modal_height:500,
				otherrow:null
				// list_footerField:[
				// 	{field:'needamount',toFixed:2}
				// ]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {
			
		},
		methods: {
			list_beforeCreateGrid(gridOptions){
				gridOptions.toolbarConfig.buttons = [{
					name: '新增',
					status: 'primary',
					code: 'add'
				}]
				gridOptions.columns = [{
						field: 'begin_time',
						title: '开始时间',
						formatter({cellValue}){
							return window.systemMethods.timestampToDate(cellValue,true)
						}
					},
					{
						field: 'end_time',
						title: '结束时间',
						formatter({cellValue}){
							return window.systemMethods.timestampToDate(cellValue,true)
						}
					},
					{
						field: 'mark',
						title: '备注',
					},
					{
						title: '操作',
						fixed: "right",
						align: 'center',
						width: 120,
						slots: {
							default: ({row}) => {
								return [
									<el-button type = "text" size = "mini" onClick = {() => {this.edit(row)}}>编辑</el-button>,
									<el-button status="danger" type = "text" size = "mini" onClick = {() => {this.del(row)}}>删除</el-button>,
								]
							}
						}
					}
				]
				gridOptions.formConfig = false
			},
			list() {
				return new Promise((resolve) => {
					this.$api.parcel.listotherdetail({
						basDistrFeeUid:this.row.basDistrFeeUid
					}).then((res)=>{
						resolve(res)
					})
					// let groupdata = this.$Lodash.groupBy(this.data, 'bankAcc')
					// for(let i in groupdata){
					// 	let obj = {}
					// 	obj.id = groupdata[i][0].id
					// 	obj.bankAcc = i
					// 	obj.accName = groupdata[i][0].accName
					// 	obj.needamount = this.$Lodash.sumBy(groupdata[i], item=>parseFloat(item.needamount))
					// 	obj.needamount = obj.needamount.toFixed(2)
					// 	data.push(obj)
					// }
					// console.log(data)
				})
			},
			submit() {
				//this.init()
			},
			reset() {
				//this.init()
			},
			configSubmit(){
				this.$refs.logisticsotherdetailList.commitProxy('query')
			},
			add(){
				this.otherrow = null
				this.$nextTick(()=>{
					this.$refs.config.modal_show()
				})
				
			},
			edit(row){
				this.otherrow = row
				this.$nextTick(()=>{
					this.$refs.config.modal_show()
				})
			},
			del(row){
				this.$confirm('是否确认删除?').then(()=>{
					this.$api.parcel.delotherdetail({
						id: row.id,
					}).then(() => {
						this.$refs.logisticsotherdetailList.commitProxy('query')
					})	
				})			
			},
		},
		components: {
			config
		}
	}
</script>